//Basic Util functions
//These functions are all browsers functions and need window and document objects

export function getCookie(cname: string) {
  const env = getDomain();

  const envCookieName = env === '' ? `${cname}=` : `${cname}-${env}=`;
  const ca = document.cookie.split(';');
  for (let c of ca) {
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(envCookieName) == 0) {
      return c.substring(envCookieName.length, c.length);
    }
  }
  return '';
}

export function setCookie(cname: string, cvalue: string, exdays: number) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();

  const env = getDomain();
  const domain = env === 'local' ? '.app.localhost' : `${env}.transflo.com`;

  const cookie = `${env === '' ? cname : `${cname}-${env}`}=${cvalue};${expires};Path=/;domain=${domain}`;
  document.cookie = cookie;
}

export function deleteAllCookies() {
  // retrieve all cookies
  const cookies = document.cookie.split(';');

  const env = getDomain();
  const domain = env === 'local' ? '.app.localhost' : `${env}.transflo.com`;

  const expires = 'expires=' + new Date(0).toUTCString();
  for (const c of cookies) {
    document.cookie = `${c};${expires};Path=/;domain=${domain}`;
  }
}

export const getDomain = () => {
  const domain = location.host.split(':')[0];
  if (domain.includes('.localhost')) {
    return 'local';
  } else if (domain.includes('.dev.')) {
    return 'dev';
  } else if (domain.includes('.qa.')) {
    return 'qa';
  } else {
    return '';
  }
};
